import { CustomExercise } from './data-model/exercise';

export interface PublishExerciseParams { exercise: CustomExercise; adminMode: boolean; }
export interface PublishExerciseResults { exercise?: CustomExercise; error?: string; }
export interface UnpublishExerciseParams { exercise: CustomExercise; adminMode: boolean; }
export interface UnpublishExerciseResults { ok?: boolean; error?: string; }
export interface PublishExerciseToCoachChannelParams { exercise: CustomExercise; }
export interface UnpublishExerciseFromCoachChannelParams { exercise: CustomExercise; }
export interface GetExerciseParams { exerciseId: string; }
export interface GetExerciseResults { exercise?: CustomExercise; error?: string; }

// The `error` getExercise answers when the exercise is genuinely not in `global_exercises`.
// Every other `error` means the server could not look, and the client must not read that as
// a missing exercise (df-f5a9c683e16d). The text is part of the wire contract: older app
// versions compare nothing, but changing it would turn every not-found into a failure.
export const GET_EXERCISE_NOT_FOUND = 'Not found';
